module.exports = __webpack_public_path__ + "static/img/recruitment.ea2ca24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/recruitment.png
// module id = csnl
// module chunks = 0